export const MALE = 1;
export const FEMALE = 2;
export const OTHER = 3;